import { collapseDrawer, expandDrawer } from '../utils/animation.js';
import dispatchEvent from '../utils/dispatch-event.js';
import EVENT from '../enums/event.js';

const selectors = {
  button: '[data-accordion-child-drawer-button]',
  content: '[data-accordion-child-drawer-content]',
  header: '[data-accordion-child-drawer-header]',
};

class AccordionChildDrawer {
  /**
   * @param {Element} element
   */
  constructor(element) {
    this.element = element;

    this.button = this.element.querySelector(selectors.button);
    this.content = this.element.querySelector(selectors.content);
    this.header = this.element.querySelector(selectors.header);

    this.init();
  }

  init() {
    this.registerEventListeners();
  }

  registerEventListeners() {
    this.button.addEventListener('click', () => {
      this.toggle();
    });
  }

  toggle() {
    const expanded = this.button.getAttribute('aria-expanded');

    if (expanded === 'true') {
      this.close();
    } else {
      this.open();
    }
  }

  close() {
    collapseDrawer(this.content);

    const parentContent = this.content.parentNode.closest(
      '[data-accordion-drawer-content]'
    );

    this.button.setAttribute('aria-expanded', 'false');
    this.element.dataset.state = 'closed';
    this.content.dataset.state = 'closed';
    parentContent.style.minHeight = 'auto';
    parentContent.style.height = 'auto';
  }

  open() {
    this.content.style.minHeight = '0px';

    expandDrawer(this.content);

    const elementHeight = this.content.scrollHeight;
    const parentContent = this.content.parentNode.closest(
      '[data-accordion-drawer-content]'
    );

    let parentContentHeight = 0;
    parentContentHeight = parentContent.clientHeight;

    this.button.setAttribute('aria-expanded', 'true');
    parentContent.style.height = `${elementHeight + parentContentHeight}px`;
    this.element.dataset.state = 'open';
    this.content.dataset.state = 'open';

    this.emitCloseAllEvent();
  }

  emitCloseAllEvent() {
    dispatchEvent(EVENT.ACCORDION.CHILDDRAWERCLOSED, this.element, {
      detail: {
        childDrawer: this,
      },
    });
  }
}

export default AccordionChildDrawer;
